/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import { Field, getIn } from 'formik';
import { FormControl, FormHelperText, Input, InputLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const RenderFileInput = ({
  label,
  field,
  form: { touched, errors, setFieldValue },
  inputProps,
  ...others
}) => {
  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  return (
    <FormControl
      variant="standard"
      error={touch && error != null}
      className={classes.formControl}
      {...others}
    >
      <InputLabel shrink>{label}</InputLabel>
      <Input
        {...inputProps}
        name={field.name}
        onChange={(e) => {
          setFieldValue(field.name, e.target.files[0]);
        }}
        type="file"
      />
      {touch && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export const FormFileInput = ({ name, placeholder, ...others }) => (
  <Field name={name} component={RenderFileInput} inputProps={{ placeholder }} {...others} />
);
